import { useState, useEffect } from 'react';
import { checkPaymentStatus } from '../services/paymentService';

interface UsePaymentStatusProps {
  reference?: string;
  paymentMethod: string;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const usePaymentStatus = ({ 
  reference,
  paymentMethod,
  onSuccess,
  onError
}: UsePaymentStatusProps) => {
  const [status, setStatus] = useState<string>('pending');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!reference || !paymentMethod) return;

    const checkStatus = async () => {
      try {
        setLoading(true);
        
        // Vérifier le statut du paiement réel
        const result = await checkPaymentStatus(reference, paymentMethod);
        const paymentStatus = result.status;
        
        setStatus(paymentStatus);
        console.log("Statut de paiement réel:", paymentStatus);
        
        // Traiter le résultat du paiement
        if (paymentStatus === 'success' || paymentStatus === 'SUCCESSFUL' || paymentStatus === 'SUCCESS') {
          onSuccess?.();
        } else if (paymentStatus === 'failed' || paymentStatus === 'FAILED') {
          throw new Error('Le paiement a échoué');
        }
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Une erreur est survenue');
        setError(error);
        onError?.(error);
      } finally {
        setLoading(false);
      }
    };

    // Vérifier le statut toutes les 5 secondes
    const interval = setInterval(checkStatus, 5000);

    // Arrêter de vérifier après 5 minutes
    const timeout = setTimeout(() => {
      clearInterval(interval);
      if (status === 'pending') {
        setError(new Error('Le délai de paiement a expiré'));
      }
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [reference, paymentMethod, onSuccess, onError, status]);

  return { status, loading, error };
};
